import React from 'react';
import '../../Home.scss';
import './Pricing.scss'
import { useFlags } from 'launchdarkly-react-client-sdk';
import ReactTooltip from "react-tooltip";

const Pricing: React.FC = () => {
    const { showNewFreeCallCount } = useFlags();
    let freeCallCount = showNewFreeCallCount ? '2,000' : '1,000';
    return (
        <div className="section pricing-section">
            <div className="w-container-pricing  price-container">
                <div className="header-container">
                    <h2 className="pricing-header-text">Monthly pricing for our APIs</h2>                    
                </div>
                <div className="shadow-container">
                    <div className="bg-container bg-contianer-2">
                        <div className="site-section">
                            <div className="context-data-4">
                                <h5 className="header-pricing-4">
                                    Site Access
                            </h5>
                                <hr className="line"></hr>
                                <div className="price-content">
                                    <div className="pricing-checkbox-ico"></div>
                                    <span className="text-content-4">$.002 per call</span>
                                </div>
                                
                            </div>
                        </div>
                        <div className="vl"></div>
                        <div className="booking-section">
                            <div className="context-data-4">
                                <h5 className="header-pricing-4">
                                    Consumer Bookings
                                    <div className="d-flex">
                                        <i className="info-icon" data-tip="Booking fees do not apply to all developer accounts,
                                but only to integrations that aggregate and/or sell services sourced
                                from multiple Mindbody software subscribers." data-for="toolTip" data-multiline="true" /></div>
                                </h5>
                                <ReactTooltip id="toolTip" place="bottom" type="dark" effect="float" className="tooltip"
                                    backgroundColor='#696C74' arrowColor='#696C74' />

                                <hr className="line line-bg-container-2"></hr>
                                <div className="price-content d-flex">
                                    <div className="pricing-checkbox-ico"></div>
                                    <span className="text-content-4">$15.00 per location, per integration</span>
                                </div>
                                <div className="price-content d-flex">
                                    <div className="pricing-checkbox-ico"></div>
                                    <span className="text-content-4">$1.30 per class booking</span>
                                </div>
                                <div className="price-content d-flex">
                                    <div className="pricing-checkbox-ico"></div>
                                    <span className="text-content-4">$2.50 per appointment booking</span>
                                </div>
                                <div className="price-content d-flex">
                                    <div className="pricing-checkbox-ico"></div>
                                    <span className="text-content-4">Free virtual booking</span>
                                </div>
                            </div>
                        </div>
                    </div>                    
                    <div className="bg-container free-res-top-border">
                        <div className="context-data-4">
                            <h5 className="header-pricing-4">
                                Free Access
                            </h5>
                            <hr className="line"></hr>
                            <div className="price-content d-flex ">
                                <div className="pricing-checkbox-ico long-text-ico"></div>
                                <span className="text-content-4">Free API access for developers with under 5,000 calls per billing cycle</span>
                            </div>
                            <div className="price-content d-flex ">
                                <div className="pricing-checkbox-ico"></div>
                                <span className="text-content-4">Free access to our Sandbox</span>
                            </div>
                            <div className="price-content d-flex " >
                                <div className="pricing-checkbox-ico"></div>
                                <span className="text-content-4">Free access to our Consumer API</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className='pricing-faqs-div'>
                <a id="btn-pricing-faqs" href="ui/faq" target='_blank'
                    className="btn w-button pricing-faqs-button">Pricing FAQs</a>
            </div>
        </div>
    )
}

export default Pricing